export const color_blanco_puro = "#FFFFFF";
export const color_blanco = "#F2F2F2";
export const color_azul = "#13304D";
export const color_naranja = "#EE7511";

export const color_verde = "#5F6D36";
export const color_turquesa = "#085D60";
export const color_violeta = "#542141";

export const color_violeta_75 = "rgba(84, 33, 65, 0.75)";
export const color_azul_75 = "rgba(19, 48, 77, 0.75)";

export const color_primario = color_violeta;
export const color_primario_hover = color_violeta_75;
export const color_fondo = color_blanco;
